import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';
import { ESTATUS_AUTORIZADO } from 'utils/constants';

export const baseURI = 'nominas/incidencias-reloj';

/**
 * GET Incidencias de Reloj Checador
 * @param {object} params (Normalmente incluye { solicitud: id })
 */
export const getIncidenciasReloj = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Incidencia de Reloj Checador individual
 */
export const getIncidenciaReloj = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Nueva Incidencia
 */
export const postIncidenciaReloj = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Incidencia agregada correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Editar Incidencia
 */
export const patchIncidenciaReloj = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Incidencia editada correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Eliminar Incidencia (Borrado lógico)
 */
export const deleteIncidenciaReloj = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Incidencia eliminada correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * AUTORIZAR Incidencia
 */
export const autorizarIncidenciaReloj = async (id) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, { estados_globales: ESTATUS_AUTORIZADO });
    onSuccess(response, 'Incidencia autorizada correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
